import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import SoftBox from "../../components/common/softBox";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import { getCreditLimitRequestDetail } from "../../features/creditLimitRequests";
import { Loader } from "../../components/common/loader";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import SoftTypography from "../../components/common/softTypography";
import { FaEye } from "react-icons/fa6";
import SoftBadge from "../../components/common/softBadge";
import { IconButton, Tooltip } from "@mui/material";

const ViewCreditLimitRequest: React.FC = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { creditLimitRequestsLoader, detail } = useAppSelector(
    (state: any) => state.creditLimitRequests
  );

  useEffect(() => {
    // // // console.log("id", id);
    if (id) {
      dispatch(getCreditLimitRequestDetail({ id }));
    }
    // // // console.log("detail", detail);
  }, [id, dispatch]);

  if (creditLimitRequestsLoader) {
    return <Loader />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        sx={{
          padding: "15px",
          backgroundColor: "#fff",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
        }}
      >
        <SoftBox
          sx={{
            fontSize: "18px",
            fontWeight: "700",
            lineHeight: "normal",
            paddingBottom: "20px",
            marginBottom: "20px",
            borderRadius: "0px",
            borderBottom: "1px solid #ccc",
            textTransform: "capitalize",
          }}
        >
          {`${detail?.user_id?.owner_name + "'s" || ""} Credit Limit Request`}
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={2}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              tag="h3"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Name: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.user_id?.owner_name || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Status: &nbsp;
            </SoftTypography>
            <SoftBadge
              variant="gradient"
              badgeContent={detail?.status}
              color={
                detail?.status === "pending"
                  ? "info"
                  : detail?.status === "reject"
                  ? "error"
                  : "success"
              }
              size="xs"
              container
            />
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={2}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              New Credit Limit: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.new_credit_limit || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Increase Percentage: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.increase_percentage || "N/A"}%
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={2}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Monthly Sales Average: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.monthly_sales_avarage || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Credit Limit Document: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              <Tooltip
                title="View Document"
                style={{ padding: 0, marginLeft: "5px" }}
              >
                <IconButton
                  component="a"
                  href={detail?.credit_limit_document_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaEye />
                </IconButton>
              </Tooltip>
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={2}
        >
          <SoftBox 
          sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}>
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Increase Reason: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.increase_limit_reason || "N/A"}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ViewCreditLimitRequest;
